<script setup lang="ts">
const props = defineProps({
  destination: {type: String, required: true},
  redirectLink: {type: String, required: false},
  icon: {type: String, required: false}
});

const defaultIcon = "ph:map-pin-bold";
</script>

<template>
  <a :href="redirectLink" target="_blank" rel="noopener noreferrer" class="approach-map-link">
    <div class="icon-box">
      <Icon v-if="props.icon !== 'none'" :name="props.icon ? props.icon : defaultIcon" size="1.2rem"/>
      <img v-else src="https://www.dhmosktzoumerkwn.gr/templates/ja_fubix/favicon.ico"
           alt="" class="municipality-icon">
    </div>
    <span class="destination-text">{{ destination }}</span>
    <span class="sr-only">({{ $t('opensInNewTab') }})</span>
    <Icon name="ph:arrow-up-right-bold" size="1rem" class="arrow-icon" aria-hidden="true"/>
  </a>
</template>

<style scoped lang="sass">
.approach-map-link
  display: flex
  align-items: center
  gap: 1rem
  padding: 1rem 1.25rem
  border-radius: 12px
  text-decoration: none
  background-color: rgba(0, 0, 0, 0.03)
  border: 1px solid rgba(0, 0, 0, 0.05)
  transition: all $transition-fast
  color: $color-text-main

  &:hover
    background-color: $color-dark-bg
    color: white
    transform: translateX(5px)
    
    .icon-box
      background-color: rgba(255, 255, 255, 0.1)
      color: white
    
    .arrow-icon
      opacity: 1
      transform: translate(2px, -2px)

.dark-mode .approach-map-link
  background-color: rgba(255, 255, 255, 0.05)
  border-color: rgba(255, 255, 255, 0.1)
  color: $color-text-light

  &:hover
    background-color: white
    color: black
    
    .icon-box
      background-color: rgba(0, 0, 0, 0.05)
      color: black

.icon-box
  width: 32px
  height: 32px
  display: flex
  align-items: center
  justify-content: center
  background-color: white
  border-radius: 8px
  color: $color-dark-bg
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05)
  transition: background-color $transition-fast

.dark-mode .icon-box
  background-color: $color-dark-bg
  color: white

.municipality-icon
  width: 18px
  height: 18px
  border-radius: 4px

.destination-text
  font-weight: 600
  font-size: 1rem
  flex: 1

.arrow-icon
  opacity: 0.3
  transition: all $transition-fast
</style>
